import { Store } from '../../../../../common/store/base/Store';
import { inject } from '../../../../../common/container/inject';

import { IActiveUserService } from '../../../../../service/public/activeUser/IActiveUserService';
import { RestActiveUserService } from '../../../../../service/public/activeUser/RestActiveUserService';

import { IRouterService, RouterServiceToken } from '../../../../../service/route/IRouterService';

import { CRUDServiceType } from '../../../../../service/common/service/CRUDServiceType';
import { ISSOAuthService } from '../../../../../service/sso/ISSOAuthService';
import { RestSSOAuthService } from '../../../../../service/sso/RestSSOAuthServie';

type ParsedSSOCallback = {
  providerId: string;
  code: string;
  state?: string;
};
const POST_LOGIN_REDIRECT_KEY = 'post_login_redirect';


export class SSOOAUTHRedirectPageDomain extends Store {
  private isProcessing = false;

  private ssoAuth: ISSOAuthService = new RestSSOAuthService(CRUDServiceType.public);

  constructor(
    protected activeUserService: IActiveUserService = new RestActiveUserService(),
    private router: IRouterService = inject<IRouterService>(RouterServiceToken),
  ) {
    super();
  }

  async boot(): Promise<void> {
    if (this.isProcessing) return;
    this.isProcessing = true;

    try {
      await this.processLogin();
    } catch (e) {
      console.error('[SSO redirect error]', e);
      const message = e?.message || '';
      if (message) {
        sessionStorage.setItem('sso_login_error', message);
      }
      this.redirectToLogin();
    } finally {
      this.isProcessing = false;
    }
  }

  protected processLogin = async () => {
    const { providerId, code, state } = this.parseCallbackParams();

    await this.ssoAuth.completeLogin(providerId, { code, state });

    await this.activeUserService.getActiveUser();

this.redirectAfterSSO();
  };

  protected parseCallbackParams(): ParsedSSOCallback {
    const params = new URLSearchParams(window.location.search);

    const code = params.get('code');
    if (!code) throw new Error('SSO code not found in URL');

    const state = params.get('state') ?? undefined;
    if (!state) throw new Error('SSO state not found in URL');

    const providerId = state.split('.')[0];
    if (!providerId) throw new Error('SSO providerId not found in state');

    return { providerId, code, state };
  }

  private redirectToLogin = () => {
    this.router.goTo('/login');
  };

  private redirectAfterSSO = () => {
  const to = sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY);
  sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY);

  if (to && to.startsWith('/') && !to.startsWith('//')) {
    this.router.goTo(to);
    return;
  }

  this.router.goTo('/');
};
}
